import React, { FunctionComponent } from 'react';

import styled, { useTheme } from 'styled-components';

import Box from '@components/layout/box';
import Grid from '@components/basics/grid';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import CircleRightArrowIcon from '@components/basics/icons/circle-right-arrow';

interface EmptySectionBoxProps {
  className?: string;
  header: React.ReactNode;
  title: React.ReactNode;
  text: React.ReactNode;
  onClick: () => void;
}

const EmptySectionBox: FunctionComponent<EmptySectionBoxProps> = ({
  className,
  header,
  title,
  text,
  children,
  onClick,
}) => {
  const theme = useTheme();
  return (
    <div className={className || ''}>
      {children}
      <Typography className="title" type="subheader" customFont="semi-bold">
        {header}
      </Typography>
      <Box>
        <Flex justifyContent="space-between" alignItems="center">
          <Grid gap={5}>
            <Typography
              className="box-title"
              type="title"
              customFont="semi-bold"
            >
              {title}
            </Typography>
            <Typography color={theme.colors.tertiary} type="small">
              {text}
            </Typography>
          </Grid>
          <CircleRightArrowIcon onClick={onClick} />
        </Flex>
      </Box>
    </div>
  );
};

export default styled(EmptySectionBox)`
  width: 100%;
  margin: 64px auto 0;

  .title {
    margin-bottom: 32px;
  }
`;
